<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="冰排编号" prop="icechopsNo">
            <el-input
              v-model="formData.icechopsNo"
              :placeholder="icechopsNoDisabled?'系统自动生成':'请输入冰排编号'"
              :disabled="icechopsNoDisabled||editType"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="冰排长度" prop="icechopsLength">
            <el-input-number
              v-model="formData.icechopsLength"
              size="small"
              style="width:100%"
              :max="162142895431250380000"
              :step="0.0001"
              :min="0.0"
              controls-position="right"
              :precision="4"
              placeholder="请输入冰排长度"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="冰排宽度" prop="icechopsWidth">
            <el-input-number
              v-model="formData.icechopsWidth"
              size="small"
              style="width:100%"
              :max="162142895431250380000"
              :step="0.0001"
              :min="0.0"
              controls-position="right"
              :precision="4"
              placeholder="请输入冰排宽度"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="冰排高度" prop="icechopsHeight">
            <el-input-number
              v-model="formData.icechopsHeight"
              size="small"
              style="width:100%"
              :max="162142895431250380000"
              :step="0.0001"
              :min="0.0"
              controls-position="right"
              :precision="4"
              placeholder="请输入冰排高度"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item label="温度范围" prop="tempRange">
            <dict-select
              filterable
              clearable
              v-model="formData.tempRange"
              placeholder="请输入温度范围"
              default
              :body="brandNameDictParams"
              :selectedLabel.sync="formData.tempTypeRange"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 12}" :md="{span: 8}" :lg="{span: 6}">
          <el-form-item label="有效状态" prop="icechopsStatus">
            <el-radio-group v-model="formData.icechopsStatus">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    icechopsCode: String,
    editType: Boolean,
    isAddPage:Boolean,
  },
  components: {},
  computed: {
    days() {
      return Array.from({length: 31}).map((v, i) => i + 1)
    },
  },
  data() {
    return {
      brandNameDictParams: {type: 'tempRange'},
      coordPickerDialogVisible: false,
      backDialogVisible: false,
      formData: {
        icechopsStatus: 'Y',
      },
      rules: {
        icechopsNo: [{
            required: true,
            message: '请输入冰排编号',
            trigger: 'change',
          },],
        tempRange: [
          {
            required: true,
            message: '请选择温度范围',
            trigger: 'change',
          },
        ],
      },
      icechopsNoDisabled: true,
    }
  },
  mounted() {
    this.getData()
    this.getSysParameter()
  },
  methods: {
    getData() {
      if (!this.icechopsCode) return
      this.$api
        .masterIcechopsDetailApi({
          icechopsCode: this.icechopsCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    getSysParameter(){
      this.$api.getSysParameterByIdApi({paramID: 'autoIcechops'})
      .then((res) => {
        this.icechopsNoDisabled = res.body.paramValue == 'Y'
        if (this.icechopsNoDisabled&&this.isAddPage){
          this.rules.icechopsNo.shift()
        }
      })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterIcechopsSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
